import React, { useContext, useState } from "react";

import { UserContext } from "../../../contexts";
import SourcedInfo from "./SourcedInfo";
import Info from "../ItemProduct/Info";
import BubbleView from "../../../core/components/Bubble/BubbleView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { getFileUrl } from "../../../core/config/api.js";

const LeadsAdditionalRecordItem = ({ item, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { user } = useContext(UserContext);

  return (
    <>
      <div className="row" key={item.id}>
        <FontAwesomeIcon
          icon={faSortDown}
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={`${isCollapsed ? "closed-arrow" : "opened-arrow"}`}
        />
        <div className="col-img item-col">
          <img
            className="product-image"
            src={getFileUrl(item?.product?.images?.[0]?.id)}
            alt="Product"
          />
        </div>

        <div className="order-details row">
          <div className="col" style={{ padding: "15px 0px" }}>
            <div className="brand">{item?.product?.brand?.name}</div>
            <div className="model">{item?.product?.model?.name}</div>

            <div className="seller">
              {user?.is_admin &&
                item.created_by &&
                !item.created_by?.is_admin &&
                "Inq: "}
              {item.px_request_id && "Part-X "}
              Order
            </div>
            <BubbleView
              count={item.additional_records.length + 1}
              where="leads-item"
            />
          </div>

          <div className="col">
            <div className="item-col">
              <Info label="Ref">{item.product?.reference_number}</Info>
            </div>
          </div>
          <div className="col"></div>
          <div className="col"></div>
          <div className="col"></div>
        </div>
      </div>

      {!isCollapsed && (
        <>
          <SourcedInfo item={item} isLeadsPage={true}>
            {children}
          </SourcedInfo>
          {item.additional_records?.map((record, index) => (
            <SourcedInfo key={index} item={record} isLeadsPage={true}>
              {children}
            </SourcedInfo>
          ))}
        </>
      )}
    </>
  );
};

export default LeadsAdditionalRecordItem;
